/**
 * Detecta se um cadastro exige ou já está no fluxo SUPEX.
 * Considera flags booleanas, solicitações de exceção e indicadores
 * dinâmicos no payload, replicando o contrato do CadastroEmpresa.
 */

import { obterStatusChave } from "./statusMapper.js";

const STATUS_TEXTO_SUPEX = ["PENDENTE_SUPEX", "APROVADO_SUPEX", "REPROVADO_SUPEX"];

const FLAGS_EXPLICITAS = [
  "encaminhar_supex",
  "encaminharSupex",
  "aprovacaoSupex",
  "requer_supex",
  "supex",
];

export function normalizarListaSolicitacoesExcecao(payload, empresa) {
  const candidatas = [
    payload?.solicitacoes_excecao,
    payload?.solicitacoesExcecao,
    empresa?.solicitacoes_excecao,
    empresa?.solicitacoesExcecao,
  ];

  const lista = candidatas.find((valor) => Array.isArray(valor));
  return Array.isArray(lista) ? lista : [];
}

export function valorBooleanoAtivo(valor) {
  if (typeof valor === "boolean") return valor;
  if (typeof valor === "number") return valor === 1;

  const texto = String(valor || "").trim().toLowerCase();
  return ["1", "true", "sim", "yes", "on"].includes(texto);
}

export function detectarIndicadorSupexDinamico(obj, profundidade = 0) {
  if (!obj || typeof obj !== "object" || profundidade > 3) return false;

  if (Array.isArray(obj)) {
    return obj.some((item) =>
      detectarIndicadorSupexDinamico(item, profundidade + 1),
    );
  }

  for (const [chave, valor] of Object.entries(obj)) {
    if (
      String(chave || "").toLowerCase().includes("supex") &&
      valorBooleanoAtivo(valor)
    ) {
      return true;
    }
    if (valor && typeof valor === "object") {
      if (detectarIndicadorSupexDinamico(valor, profundidade + 1)) return true;
    }
  }

  return false;
}

function lerHintSupexLocal(documento, id) {
  if (typeof window === "undefined") return false;
  try {
    const hints = JSON.parse(
      window.localStorage.getItem("empresa_supex_hints") || "{}",
    );
    if (documento && hints[documento]?.requerSupex) return true;
    if (Number.isInteger(id) && id > 0 && hints[`id:${id}`]?.requerSupex)
      return true;
  } catch {
    /* sem impacto */
  }
  return false;
}

export function obterHintSupexLocal(empresa, payload, empresaRef) {
  const documento = [
    empresa?.cnpj,
    empresa?.CNPJ,
    empresa?.cpf,
    empresa?.CPF,
    empresa?.documento,
    payload?.cnpj,
    payload?.CNPJ,
    payload?.cpf,
    payload?.CPF,
    payload?.documento,
    empresaRef?.documento,
  ].find((valor) => String(valor || "").trim());

  const docNormalizado = String(documento || "").replace(/\D/g, "");
  const idEmpresa = Number(
    empresa?.id ??
      empresa?.ID ??
      empresa?.id_empresa ??
      empresa?.empresa_id ??
      empresaRef?.id ??
      0,
  );

  return lerHintSupexLocal(docNormalizado, idEmpresa);
}

/**
 * Decide se o cadastro precisa (ou já passou) pela etapa SUPEX.
 */
export function cadastroRequerSupex(
  empresa,
  payload,
  listaExcecoes,
  empresaRef,
) {
  if (Array.isArray(listaExcecoes) && listaExcecoes.length > 0) return true;

  const flags = FLAGS_EXPLICITAS.flatMap((campo) => [
    empresa?.[campo],
    payload?.[campo],
  ]);
  if (flags.some(valorBooleanoAtivo)) return true;

  if (detectarIndicadorSupexDinamico(empresa)) return true;
  if (detectarIndicadorSupexDinamico(payload)) return true;
  if (detectarIndicadorSupexDinamico(empresaRef)) return true;

  const statusChave = obterStatusChave(empresa?.status ?? payload?.status);
  if (STATUS_TEXTO_SUPEX.includes(statusChave)) return true;

  return obterHintSupexLocal(empresa, payload, empresaRef);
}
